// istanbul ignore file
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';

export const StyledNavigationLinkContainer = styled.div`
  width: 100%;
  overflow: hidden;
  padding-right: ${globalTheme.spacing.md};
`;
